module.exports = __webpack_public_path__ + "img/heart-filled.da4d28c0.svg";